<template>
  <span
    class="cursor-pointer hover:text-gray-800 mx-1"
    @click="bcFolderStore.toggleView()"
  >
    <aw-icon
      :icon="bcFolderStore.view === 'table' ? 'grid' : 'list'"
      class="w-6 xl:w-4 h-6 xl:h-4"
    />
  </span>
  <span
    class="cursor-pointer hover:text-gray-800 mx-1"
    @click="bcHomeStore.toggleOrder()"
  >
    <aw-icon
      :icon="bcHomeStore.order === 'date' ? 'sort-az' : 'sort-19'"
      class="w-6 xl:w-4 h-6 xl:h-4"
    />
  </span>
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcHomeStore from '@/frontapp/store/bcHome'

export default {
  computed: {
    ...mapStores(useBcFolderStore, useBcHomeStore)
  }
}
</script>

<style lang="scss" scoped></style>
